import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import { useNavigate } from "react-router-dom";
import MainTitle from "./MainTitle";
import PrivacyModal from "./PrivacyModal";
import Footer from "../Footer";
import Models from "./Models";
import AIEnterprise from "./AIEnterprise";
import Data from "./Data";
import UseCase from "./UseCase";
import InputField from "./InputField";
import Sidebar from "../Sidebar";
import ModaleLogin from "./ModaleLogin";
import InfiniteCards from "./InfiniteCards";
import FirstSection from "./2.0/FirstSection";
const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const MainFrameHome = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(true)
    const [selectedLink, setSelectedLink] = useState(1)

    const toggleSidebar = () => {
        sidebarOpen ? setSidebarOpen(false) : setSidebarOpen(true)
    }

    useEffect(() => {
        const cookieAccepted = document.cookie.split(";").some((item) => item.trim().startsWith("visitorprojecte8="));

        if (!cookieAccepted) {
            const timer = setTimeout(() => {
                setShowModal(true);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, []);

    const getUserDeviceInfo = () => {
        return {
            deviceType: /Mobi|Android/i.test(navigator.userAgent) ? "Mobile" : "Desktop",
            browser: navigator.userAgent,
            platform: navigator.platform,
        };
    };

    const handleAccept = () => {
        const deviceInfo = getUserDeviceInfo();
        const timestamp = new Date().toISOString();
        const data = {
            userAcceptedCookies: true,
            ...deviceInfo,
            timestamp,
        };

        // fetch(`${GEN_BACKEND_LINK}/website_info_visitors`, {
        //     method: "POST",
        //     headers: { "Content-Type": "application/json" },
        //     body: JSON.stringify(data),
        // })
        //     .then((response) => response.json())
        //     .then(() => console.log("Thanks for the trust."))
        //     .catch((error) => console.error("Error saving data:", error));

        document.cookie = "visitorprojecte8=true; path=/; max-age=31536000; Secure; SameSite=Strict";
        setShowModal(false);
    };

    const handleDecline = () => {
        setShowModal(false);
    };

    const NavigatePagesHome = (page) => {
        navigate(`/resources/${page}`);
    };

    useEffect(() => {
        setTimeout(() => setLoading(false), 1500);
    }, []);

    return (
        <div>
            <div className="main_frame_home">
                <Navbar toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen}/>
                <div className="main_frame_inner">
                    <Sidebar sidebarOpen={sidebarOpen} setSelectedLink={setSelectedLink} selectedLink={selectedLink}/>
                    <div className="main_frame_cont">

                        <InputField selectedLink={selectedLink} />
                        {/* <MainTitle/> */}
                        {/* <InfiniteCards selectedLink={selectedLink}/> */}
                        <UseCase selectedLink={selectedLink}/>
                        {/* <Data/> */}
                        {/* <Models selectedLink={selectedLink}/> */}
                        <AIEnterprise />

                        {/* <FirstSection/> */}

                        <PrivacyModal onAccept={handleAccept} onDecline={handleDecline} showModal={showModal} />
                        <Footer NavigatePagesHome={NavigatePagesHome} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainFrameHome;
